// i18n系统主要导出文件

export { LanguageProvider, useLanguage } from './LanguageContext';
export { useTranslation } from './useTranslation';
export { 
  SUPPORTED_LANGUAGES, 
  DEFAULT_LANGUAGE, 
  getLanguageByCode, 
  isLanguageSupported,
  type Language 
} from './languages';
export { 
  detectBrowserLanguage, 
  getBrowserTimezone, 
  getBrowserNumberFormat 
} from './detectLanguage';
export { 
  saveLanguagePreference, 
  loadLanguagePreference, 
  clearLanguagePreference, 
  isLocalStorageAvailable 
} from './storage';
export { 
  loadTranslations, 
  translate, 
  translateBatch, 
  clearTranslationCache, 
  getCachedLanguages, 
  preloadTranslations,
  type TranslationKey, 
  type TranslationParams, 
  type TranslationValues 
} from './translate';